/**
 * Police buildings.
 *
 * 93 citywide, most named. A small, stable set — this is not live data and does
 * not pretend to be; it is where the stations are. It reads a static file baked
 * at build time (scripts/bake.mjs), not the /api/services endpoint: the API is
 * downtown-only and found 11, while the citywide OSM query finds 93 across the
 * metro. Re-baking is a human step (`npm run data:bake`), so this file only
 * changes when someone regenerates and commits it.
 *
 * The building itself is tinted deep red rather than being marked with a dot
 * over it — see markPolice in map/buildings.js. A glowing point above a roof
 * says something is here without saying which structure it is, and the
 * structure is the whole answer.
 *
 * The layer itself draws nothing. Permanent red name labels on every station
 * were shouting at all times about something that never changes; the name
 * belongs on hover, where you asked for it. Red stays reserved for this:
 * incidents are teal, road work amber, events violet, static fabric grey.
 */

import { Layer } from "./base.js";
import { palette } from "../theme/palette.js";

export class PoliceLayer extends Layer {
  static key = "police";
  static label = "Police";
  static description = "Police buildings from OSM";

  async load() {
    this.status = "loading";
    try {
      const response = await fetch(`${this.basePath}/services.json`);
      if (!response.ok) throw new Error(String(response.status));
      const body = await response.json();
      this._stations = body.stations ?? [];
      this.status = this._stations.length ? "ready" : "unavailable";
      this.detail = `${this._stations.length} stations`;
      return null;
    } catch (error) {
      this.status = "unavailable";
      this.detail = `Unavailable (${error.message})`;
      return null;
    }
  }

  get loadedCount() {
    return this._stations?.length ?? 0;
  }

  legend() {
    return [{ rgb: palette().police, label: "Police", note: "Police buildings mapped in OSM." }];
  }

  describe(station) {
    const rows = [["Type", "Police"]];
    if (station.operator) rows.push(["Operator", station.operator]);
    if (station.address) rows.push(["Address", station.address]);
    if (station.phone) rows.push(["Phone", station.phone]);
    rows.push(["Source", "OpenStreetMap"]);
    return { title: station.name || "Police building", rows };
  }

  render() {
    if (!this.enabled || this.status !== "ready") {
      this.visibleCount = 0;
      return [];
    }
    const data = this._stations;
    this.visibleCount = data.length;

    return [
    ];
  }
}
